import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/PersonalInfo/messages';

export default (props: any) =>
  Yup.object().shape({
    identifiant: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
  });
